import React from 'react'
import PDFViewer from '../../components/msi/PdfViewer'
import '../../components/msi/MsiDetail.css'

function Faculty() {
  return (
    <div style={{ paddingTop: '150px', paddingBottom: '40px', display: 'flex', justifyContent: 'center', background: '#fff', minHeight: '100vh' }}>
      <div className='faculty-pdf-wrap'>
        <PDFViewer file='tmc-faculty-details-aug-2026.pdf' params='navpanes=0&view=FitH' />
      </div>
    </div>
  )
}

export default Faculty
